import type { DeliveryDatesApiResponse } from '@app/data/clients/deliveryDatesClient/types';

// Re-export the shared types from the sub-client. Client-side consumers
// MUST import from this API-route types module (never from
// `@app/data/clients/*`) so no server-only code leaks into the client bundle.
// See docs/docs/adr/0027-type-safe-client-side-fetch-for-api-routes.md.
export type {
  DeliveryDatesApiResponse,
  DeliveryDatesDetail,
  DeliveryTimeFrame,
  LastOrderByDate,
} from '@app/data/clients/deliveryDatesClient/types';
export { DeliveryTimeFrameType } from '@app/data/clients/deliveryDatesClient/types';

export type DeliveryDatesAPIResponse =
  | DeliveryDatesApiResponse
  | { error: string };
